(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ai-mistress"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    const chat = root.querySelector('[data-mistress-chat]');
    const form = root.querySelector('[data-mistress-form]');
    const input = form && form.querySelector('input[name="prompt"]');
    const proxy = root.getAttribute('data-mistress-proxy') || '';

    function appendMsg(role, text, opts) {
      const msg = document.createElement('div');
      msg.className = 'mistress__msg mistress__msg--' + role + (opts && opts.typing ? ' mistress__msg--typing' : '');
      const avatar = document.createElement('div');
      avatar.className = 'mistress__msg-avatar';
      avatar.setAttribute('aria-hidden', 'true');
      avatar.textContent = role === 'user' ? 'You' : 'D';
      const body = document.createElement('div');
      body.className = 'mistress__msg-body';
      const txt = document.createElement('div');
      txt.className = 'mistress__msg-text';
      txt.textContent = text;
      body.appendChild(txt);
      msg.appendChild(avatar);
      msg.appendChild(body);
      chat.appendChild(msg);
      chat.scrollTop = chat.scrollHeight;
      return msg;
    }

    async function send(prompt) {
      if (!prompt.trim()) return;
      appendMsg('user', prompt);
      input.value = '';
      const typing = appendMsg('bot', '…', { typing: true });
      try {
        if (!proxy) throw new Error('no-proxy');
        const r = await fetch(proxy, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ prompt })
        });
        if (!r.ok) throw new Error('proxy-error');
        const data = await r.json();
        typing.classList.remove('mistress__msg--typing');
        typing.querySelector('.mistress__msg-text').textContent = data.reply || data.message || data.completion || 'No reply.';
      } catch (err) {
        typing.classList.remove('mistress__msg--typing');
        typing.querySelector('.mistress__msg-text').textContent = err.message === 'no-proxy'
          ? 'AI proxy not configured yet. Once your Cloudflare Worker is deployed and the proxy URL is filled in theme settings, I will be online. — Mistress D'
          : 'Connection error. Try again in a moment.';
      }
    }

    form.addEventListener('submit', (e) => { e.preventDefault(); send(input.value); });
    root.addEventListener('click', (e) => {
      const sug = e.target.closest('[data-mistress-suggest]');
      if (sug) { input.value = sug.textContent.trim(); send(input.value); }
    });
  }
  document.querySelectorAll('[data-mistress-proxy]').forEach(init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-main"] && !Shopify.designMode) return;
  try {
    
(function () {
  // ── Usage > Using/Care tab switcher (inside accordion).
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-acc-tab]');
    if (!tab) return;
    var target = tab.getAttribute('data-acc-tab');
    var tabs = tab.closest('[data-acc-tabs]');
    if (!tabs) return;
    tabs.querySelectorAll('[data-acc-tab]').forEach(function (t) {
      var active = t.getAttribute('data-acc-tab') === target;
      t.classList.toggle('is-active', active);
      t.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    tabs.querySelectorAll('[data-acc-panel]').forEach(function (p) {
      var active = p.getAttribute('data-acc-panel') === target;
      p.classList.toggle('is-active', active);
      if (active) { p.removeAttribute('hidden'); } else { p.setAttribute('hidden', ''); }
    });
  });

  // ── Pairs Well With quick-add — optimistic. Open drawer, drop an
  // optimistic line scraped from the card, then fire /cart/add.js in
  // background. refreshCart()'s section swap replaces the placeholder.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.pdp__pair-cta[data-pair-add]');
    if (!btn || btn.disabled) return;
    var id = btn.getAttribute('data-variant-id');
    if (!id) return;
    e.preventDefault();
    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'adding…';

    var card = btn.closest('.pdp__pair');
    var titleEl = card && card.querySelector('.pdp__pair-title');
    var imgEl = card && card.querySelector('.pdp__pair-img');
    var priceEl = card && card.querySelector('.pdp__pair-price');
    var payload = {
      title: titleEl ? titleEl.textContent.trim() : '',
      image: imgEl ? (imgEl.currentSrc || imgEl.src) : '',
      price: priceEl ? priceEl.textContent.trim() : '',
      quantity: 1
    };

    var drawer = document.querySelector('[data-cart-drawer]');
    if (drawer) {
      drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    var optimisticLine = (window.DISCIPLAY && window.DISCIPLAY.cart && window.DISCIPLAY.cart.optimisticAdd)
      ? window.DISCIPLAY.cart.optimisticAdd(payload) : null;

    var addPromise = (window.DISCIPLAY && window.DISCIPLAY.cart && window.DISCIPLAY.cart.add)
      ? window.DISCIPLAY.cart.add({ id: id, quantity: 1 })
      : fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: id, quantity: 1 })
        }).then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); });

    addPromise.then(function () {
      btn.classList.add('is-added');
      btn.textContent = 'added ✓';
      setTimeout(function () {
        btn.textContent = original;
        btn.classList.remove('is-added');
        btn.disabled = false;
      }, 1600);
    }).catch(function (err) {
      // Only roll back if /cart/add.js itself rejected. theme.js tags those
      // errors with `.status`; an unmarked throw means the add succeeded but
      // a downstream refresh call failed — common on preview URLs where
      // /cart.js 403's across the primary domain. The item is in the cart
      // (and the section swap may already have replaced our placeholder),
      // so we keep the optimistic line and show success.
      if (err && err.status) {
        if (window.DISCIPLAY && window.DISCIPLAY.cart && window.DISCIPLAY.cart.rollbackOptimistic) {
          window.DISCIPLAY.cart.rollbackOptimistic(optimisticLine, 1);
        }
        btn.textContent = 'error';
      } else {
        btn.classList.add('is-added');
        btn.textContent = 'added ✓';
      }
      setTimeout(function () {
        btn.textContent = original;
        btn.classList.remove('is-added');
        btn.disabled = false;
      }, 1600);
    });
  });

  // ── Vertical thumb rail: show ▲/▼ when more than 5 thumbs, scroll by 1 step.
  var thumbsRoot = document.querySelector('[data-pdp-thumbs]');
  var track = document.querySelector('[data-pdp-thumbs-track]');
  if (thumbsRoot && track) {
    var upBtn = thumbsRoot.querySelector('[data-pdp-thumbs-step="-1"]');
    var downBtn = thumbsRoot.querySelector('[data-pdp-thumbs-step="1"]');
    var thumbs = track.querySelectorAll('.pdp__thumb');
    var overflows = thumbs.length > 5;
    if (overflows && upBtn && downBtn) {
      upBtn.hidden = false;
      downBtn.hidden = false;
      var step = function () {
        var first = track.querySelector('.pdp__thumb');
        if (!first) return 88;
        var rect = first.getBoundingClientRect();
        return rect.height + 8; /* thumb + gap */
      };
      var sync = function () {
        var atTop = track.scrollTop <= 1;
        var atBottom = track.scrollTop + track.clientHeight >= track.scrollHeight - 1;
        upBtn.disabled = atTop;
        downBtn.disabled = atBottom;
      };
      upBtn.addEventListener('click', function () { track.scrollBy({ top: -step(), behavior: 'smooth' }); });
      downBtn.addEventListener('click', function () { track.scrollBy({ top: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', sync, { passive: true });
      sync();
    }
  }

  var sticky = document.querySelector('[data-pdp-sticky]');
  var buyRow = document.querySelector('[data-pdp-buy-row]');
  var form = document.querySelector('.pdp__form');
  if (!sticky) return;

  // Visible only when (a) the main buy row is scrolled out of view AND
  // (b) the footer hasn't started revealing. The footer is position:fixed and
  // fades in over its own height near the page bottom; once we're within that
  // zone the bar slides away smoothly (CSS transition) instead of sitting over
  // the footer. Distance-to-bottom is computed here directly rather than read
  // from theme.js's --footer-opacity, which can lag a frame on the last scroll.
  var pastBuyRow = false;
  function syncVisible() {
    var footer = document.querySelector('.site-footer');
    var footerH = footer ? footer.offsetHeight : 320;
    var distFromBottom = document.documentElement.scrollHeight
      - window.scrollY - window.innerHeight;
    var nearFooter = distFromBottom < footerH + 24;
    var show = pastBuyRow && !nearFooter;
    sticky.classList.toggle('is-visible', show);
    sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
  }

  if (buyRow && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      pastBuyRow = !e.isIntersecting && e.boundingClientRect.top < 0;
      syncVisible();
    }, { threshold: 0 });
    io.observe(buyRow);
  }
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { syncVisible(); ticking = false; });
  }, { passive: true });

  // Sticky ADD button submits the real PDP form.
  var stickyAdd = sticky.querySelector('[data-pdp-sticky-add]');
  if (stickyAdd && form) {
    stickyAdd.addEventListener('click', function () {
      if (typeof form.requestSubmit === 'function') { form.requestSubmit(); }
      else { form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true })); }
    });
  }

  // Keep the price + thumbnail in the sticky bar in sync with the option radios.
  var priceEl = sticky.querySelector('[data-pdp-sticky-price]');
  var imgEl = sticky.querySelector('[data-pdp-sticky-img]');
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-pdp-option]')) return;
    var f = e.target.closest('form');
    if (!f) return;
    var select = f.querySelector('#pdp-variant-id');
    if (!select) return;
    // Resolve the matching <option> straight from the checked option radios.
    // Don't read select.selectedIndex: theme.js syncs the select in a sibling
    // 'change' listener, and listener order isn't guaranteed — if we ran first
    // we'd read the previous variant and the thumbnail would lag a step behind.
    var chosen = Array.prototype.map.call(
      f.querySelectorAll('[data-pdp-option]:checked'),
      function (r) { return r.value; }
    );
    var opt = null;
    Array.prototype.forEach.call(select.options, function (o) {
      var vals = o.textContent.split(' / ').map(function (v) { return v.trim(); });
      if (chosen.length && chosen.every(function (v, i) { return v === vals[i]; })) opt = o;
    });
    if (!opt) opt = select.options[select.selectedIndex];
    if (!opt) return;
    if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;
    if (imgEl) {
      // Clear srcset when the variant has no image of its own, so the fallback
      // src wins instead of a stale srcset candidate sticking around.
      imgEl.srcset = opt.dataset.imageSrcset || '';
      imgEl.src = opt.dataset.image || imgEl.dataset.fallback;
    }
    // Swap the main gallery hero to the variant's image too — otherwise the big
    // image stays on the default variant while the sticky thumb follows along,
    // and the two disagree. Mirrors the thumbnail-click swap in theme.js.
    var heroSrc = opt.dataset.hero;
    var hero = document.getElementById('pdp-hero-img');
    if (heroSrc && hero) {
      var file = function (s) { return (s || '').split('?')[0].split('/').pop(); };
      if (file(hero.currentSrc || hero.src) !== file(heroSrc)) {
        hero.style.opacity = '0';
        var pre = new Image();
        pre.onload = function () {
          hero.removeAttribute('srcset');
          hero.removeAttribute('sizes');
          hero.src = heroSrc;
          hero.style.opacity = '1';
        };
        pre.src = heroSrc;
      }
      // Re-highlight the gallery thumbnail that matches the variant image.
      document.querySelectorAll('[data-pdp-thumb]').forEach(function (t) {
        t.classList.toggle('is-active', file(t.getAttribute('data-img-src')) === file(heroSrc));
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-voice"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Pick a random ambient palette per page load unless data-palette is
  // already set on the section root. Future: read data-palette from a
  // product metafield (e.g. product.metafields.custom.voice_palette) for
  // per-product color matching — Liquid would emit data-palette inline
  // and this JS branch becomes a no-op.
  var sec = document.querySelector('.pvoice--solid');
  if (!sec || sec.dataset.palette) return;
  var palettes = ['nightclub', 'crimson', 'iridescent', 'embers', 'redwhite'];
  sec.dataset.palette = palettes[Math.floor(Math.random() * palettes.length)];
})();

  } catch(e) { console.error(e); }
})();
})();
